export * from "./privacy-phone-footer";
export * from "./privacy-footer";
